module.exports = __webpack_public_path__ + "static/media/janira.7aeed6f7.jpg";